import { render, staticRenderFns } from "./StepUserRegistration.vue?vue&type=template&id=0cc21fec"
import script from "./StepUserRegistration.vue?vue&type=script&lang=js"
export * from "./StepUserRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports